export default {
    'SET_CHAMADAS'(state, chamadas)
    {
        state.chamadas = {...chamadas}
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/protaxi/mutations.js